/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LessenInputs */

const nl_nav_lessen = /** @type {(inputs: Nav_LessenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessen`)
};

/**

* @param {Nav_LessenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const nav_lessen = /** @type {((inputs?: Nav_LessenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LessenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_nav_lessen(inputs)
});
export { nav_lessen as "nav.lessen" }